import { useState, useEffect, useCallback } from 'react';
import { HealthCheckService } from '../services/healthCheckService.js';

/**
 * Hook customizado para gerenciar o estado de manutenção do totem
 * 
 * ATUALIZADO: Removida a ativação automática da Stone
 * O novo HealthCheck do backend já trata corretamente:
 * - Caso G002: considerado sucesso (ativação será feita apenas no pagamento)
 * - Dispositivo ativado: considerado sucesso direto
 */
export const useMaintenanceMode = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [healthData, setHealthData] = useState(null);
  const [lastCheck, setLastCheck] = useState(null);

  // Intervalo de verificação (1 minuto = 60000 ms)
  const CHECK_INTERVAL = 60000;

  /**
   * Executa verificação de healthcheck
   * ATUALIZADO: Removidas tentativas de ativação automática
   * Agora confia apenas no HealthCheck do backend que trata os casos corretos
   */
  const performHealthCheck = useCallback(async () => {
    // Não executar healthcheck nas telas de pagamento
    const currentPath = window.location.pathname;
    if (currentPath === '/select-payment' || currentPath === '/payment') {
      return;
    }

    try {
      const result = await HealthCheckService.checkPaymentMethods();
      setHealthData(result.data);
      setLastCheck(new Date());

      // Verifica se há métodos críticos offline
      const hasCriticalOffline = HealthCheckService.hasCriticalPaymentMethodsOffline(result.data);
      
      console.log('HealthCheck realizado:', {
        isHealthy: result.data.isHealthy,
        maintenanceMode: hasCriticalOffline,
        paymentMethods: result.data.paymentMethods,
        checkedAt: result.data.checkedAt
      });

      // REMOVIDO: Tentativas de ativação automática da Stone
      // O novo HealthCheck do backend já considera:
      // - G002 como sucesso (não offline)
      // - Dispositivo ativado como sucesso
      // A ativação só acontece no momento do pagamento quando necessário

      setIsMaintenanceMode(hasCriticalOffline);

    } catch (error) {
      console.error('Erro no healthcheck:', error);
      // Em caso de erro, assume modo manutenção por segurança
      setIsMaintenanceMode(true);
      setHealthData({
        isHealthy: false,
        message: 'Erro de comunicação com o servidor',
        paymentMethods: {}
      });
    }
  }, []); // Removida dependência de variáveis que não existem mais

  // Configurar verificação automática
  useEffect(() => {
    // Executa primeira verificação
    performHealthCheck();

    // Configura intervalo de verificação
    const interval = setInterval(performHealthCheck, CHECK_INTERVAL);

    // Cleanup
    return () => {
      clearInterval(interval);
    };
  }, [performHealthCheck]);

  return {
    isMaintenanceMode,
    healthData,
    lastCheck
  };
};